const getFormFields = (group) => [
    {
        id: 'lkCommon',
        name: 'common',
        value: null,
        label: group.lkCommon?.lbl,
        options: group.lkCommon?.lookup,
        gridSizes: {
            xs: 12,
            md: 12
        },
        type: 'dropdown',
        required: true
    },
    {
        id: 'lblDateFrom',
        name: 'dateFrom',
        value: null,
        label: group.lblDateFrom,
        type: 'date',
        gridSizes: {
            xs: 12,
            md: 12
        },
        required: true
    },
    {
        id: 'lblDateTo',
        name: 'dateTo',
        value: null,
        label: group.lblDateTo,
        type: 'date',
        gridSizes: {
            xs: 12,
            md: 12
        },
        required: true
    },
    {
        id: 'lblIssuedAt',
        name: 'issuedAt',
        value: null,
        label: group.lblIssuedAt,
        type: 'date',
        gridSizes: {
            xs: 12,
            md: 12
        },
        required: true
    },
    {
        id: 'lblIssuedBy',
        name: 'issuedBy',
        value: null,
        label: group.lblIssuedBy,
        gridSizes: {
            xs: 12,
            md: 12
        },
        type: 'string',
        required: true
    },
    {
        id: 'lblNumber',
        name: 'number',
        value: null,
        label: group.lblNumber,
        type: 'string',
        gridSizes: {
            xs: 12,
            md: 12
        },
        required: true
    },
    {
        id: 'lblComments',
        name: 'comments',
        value: null,
        label: group.lblComments,
        gridSizes: {
            xs: 12,
            md: 12
        },
        type: 'string',
        required: false
    }
];

export const formatFileGroups = (fileGroups) =>
    fileGroups?.map((group) => ({
        ...group,
        id: group.type,
        name: group.descr,
        description: group.descr,
        formFields: getFormFields(group),
        fileValidation: {
            max: group.max
        },
        bundles: group.files?.map((bundle) => ({
            id: bundle?.bundleId,
            files: bundle?.pages?.map((file) => ({
                id: file?.id,
                name: file?.origFName,
                extension: file?.fileExt,
                type: file?.contentType,
                position: file?.position
                /* values: {
                    dateFrom: file?.dateFrom,
                    dateTo: file?.dateTo,
                    issuedAt: file?.issuedAt,
                    issuedBy: file?.issuedBy,
                    comments: file?.comments,
                    number: file?.number,
                    common: group?.lkCommon?.lookup?.find((option) => option.value === file?.common)?.value
                } */
            })),
            values: {
                dateFrom: bundle?.pages[0]?.dateFrom,
                dateTo: bundle?.pages[0]?.dateTo,
                issuedAt: bundle?.pages[0]?.issuedAt,
                issuedBy: bundle?.pages[0]?.issuedBy,
                comments: bundle?.pages[0]?.comments,
                number: bundle?.pages[0]?.number,
                common: group?.lkCommon?.lookup?.find((option) => option.value === bundle?.pages[0]?.common)?.value
            }
        }))
    }));
